import { SvgIcon } from "@mui/material";
import { IconProps } from "../_interface";

const TrustBusiness = (props: IconProps) => {
  return(
    <SvgIcon {...props} color="inherit" viewBox="0 0 48 49">
      <svg width="48" height="49" viewBox="0 0 48 49" fill="none" xmlns="http://www.w3.org/2000/svg">
      <circle cx="24" cy="24.5" r="24" fill="#E2E4E5"/>
      <path d="M22 28.5V27.5H15.01L15 31.5C15 32.61 15.89 33.5 17 33.5H31C32.11 33.5 33 32.61 33 31.5V27.5H26V28.5H22ZM32 19.5H27.99V17.5L25.99 15.5H21.99L19.99 17.5V19.5H16C14.9 19.5 14 20.4 14 21.5V24.5C14 25.61 14.89 26.5 16 26.5H22V24.5H26V26.5H32C33.1 26.5 34 25.6 34 24.5V21.5C34 20.4 33.1 19.5 32 19.5ZM26 19.5H22V17.5H26V19.5Z" fill="#2E434D"/>
      </svg>
    </SvgIcon>
  );
}

export default TrustBusiness;